module.exports = __webpack_public_path__ + "img/recent-work-03.e14e8282.jpg";